$(function () {
    'use strict';

    var map;

    var bannieresArtisans = {
        displayModal: function(artisan) {
            var $modal = $('#modal-artisan');

            $modal.find('img.icon-categorie').attr('src', artisan.categorie.icon);
            $modal.find('.modal-title').text(artisan.enseigne);
            $modal.find('.modal-header h4').text(artisan.categorie.libelle);
            $modal.find('img.logo-artisan').attr('src', artisan.logo);

            $modal.find('#modal-adresse').text(artisan.adresse);

            var $modalTel = $modal.find('#modal-tel');
            if (artisan.telephone || artisan.telephonePortable) {
                $modalTel.removeClass('d-none');
                var html = [
                    artisan.telephone ? '<a href="tel:' + artisan.telephone + '" target="_blank">' + artisan.telephone + '</a>' : '',
                    artisan.telephonePortable ? '<a href="tel:' + artisan.telephonePortable + '" target="_blank">' + artisan.telephonePortable + '</a>' : ''
                ].filter(Boolean).join(' / ');
                $modalTel.find('span').html(html);
            } else {
                $modalTel.addClass('d-none').find('span').html('');
            }

            if (artisan.siteWeb) {
                $modal.find('#modal-url').removeClass('d-none')
                    .find('a').attr('href', artisan.siteWeb).text(artisan.siteWeb);
            } else {
                $modal.find('#modal-url').addClass('d-none');
            }

            if (artisan.email) {
                $modal.find('#modal-email').removeClass('d-none')
                    .find('a').attr('href', 'mailto:' + artisan.email).text(artisan.email);
            } else {
                $modal.find('#modal-email').addClass('d-none');
            }

            if (artisan.description) {
                $modal.find('#modal-description').removeClass('d-none').html(nl2br(artisan.description));
            } else {
                $modal.find('#modal-description').addClass('d-none');
            }

            $('#modal-tel a').off().on('click', function() {
                bannieresArtisans.incrementeStatistiques(artisan.idPub, artisan.sha, 'clickTel');
            });
            $('#modal-url a').off().on('click', function() {
                bannieresArtisans.incrementeStatistiques(artisan.idPub, artisan.sha, 'clickSiteWeb');
            });
            $('#modal-email > a').off().on('click', function() {
                bannieresArtisans.incrementeStatistiques(artisan.idPub, artisan.sha, 'clickEmail');
            });
        },

        incrementeStatistiques: function (idPub, sha, type) {
            $.ajax('ajax/incrPubArtisan/' + idPub + '/' + sha + '/' + type);
        }
    };

    function displayMap(coord) {
        map = new google.maps.Map(
            document.getElementById('map-modal-banniere-artisan'), {zoom: 10, center: coord}
        );
        // The marker, positioned at Uluru
        var marker = new google.maps.Marker({position: coord, map: map});

        // $("#modal-artisan").off().on("shown.bs.modal", function () {
        //     google.maps.event.trigger(map, "resize");
        // });
    }

    $(document).ready(function () {

        $('.slide-artisan-element').click(function() {
            bannieresArtisans.displayModal({
                enseigne: this.getAttribute('data-raisonSociale'),
                categorie: {
                    icon: this.getAttribute('data-activite-icon'),
                    libelle: this.getAttribute('data-activite')
                },
                telephone: this.getAttribute('data-telephone'),
                telephonePortable: this.getAttribute('data-telephone-portable'),
                adresse: this.getAttribute('data-adresse'),
                email: this.getAttribute('data-email'),
                siteWeb: this.getAttribute('data-site-web'),
                description: this.getAttribute('data-description'),
                logo: $(this).find('img').attr('src'),
                idPub: this.getAttribute('data-id-pub'),
                sha: this.getAttribute('data-sha'),
            });
            var $modal = $('#modal-artisan');
            var coordonnees = {
                lat: +this.getAttribute('data-latitude'),
                lng: +this.getAttribute('data-longitude')
            };

            displayMap(coordonnees);

            $modal.modal('show');
            bannieresArtisans.incrementeStatistiques(this.getAttribute('data-id-pub'), this.getAttribute('data-sha'), 'click');
        });

    });
});
